import { UploadActions } from './actions';
import {produce} from "immer";
import { NEW_ORDER_INIT_STATE } from '../../containers/CreateOrder/constants'
// Events from an upload in progress; they carry the object (e.g. order) the file is uploaded to.
export const uploadEventTypes = [UploadActions.UPLOAD_PROGRESS, UploadActions.UPLOAD_SUCCESS, UploadActions.UPLOAD_FAILURE];

const initialState = {
    uploadedFiles: [], // keep this as immutable List
}

export function createUploadReducer(shouldProcessCallback) {
    if (shouldProcessCallback == undefined) {
        throw Error("must define shouldProcessCallback.");
    }

    return function uploadReducer(state = initialState, action) {
        if (shouldProcessCallback(action) === false) {
            return state;
        }
        return produce(state, (draft) => {
            // Events for a file no longer in the list (e.g. an upload still running for an order the user
            // has navigated away from, after the list was re-initialised) are ignored.
            const indexOfFile = () => state.uploadedFiles.findIndex(item => item.fileName == action.fileName);
            let fileIndex;
            switch (action.type) {
                case UploadActions.UPLOAD_INIT:
                case NEW_ORDER_INIT_STATE:
                    var uploadedFiles = [];
                    if (action.attachments) {
                        action.attachments.forEach((att) => {
                            var file = {
                                fileName: att.name,
                                path: att.fileLocation,
                                progress: 1,
                                isNotDownloadable: att.isNotDownloadable || false
                            };

                            uploadedFiles.splice(0, 0, file);
                        });
                    }

                    draft.uploadedFiles = uploadedFiles;
                    break;

                case UploadActions.UPLOAD_REQUEST:
                    var file = {
                        fileName: action.file.name,
                        progress: 0
                    };

                    draft.uploadedFiles.splice(state.uploadedFiles.length, 0, file);
                    break;

                case UploadActions.UPLOAD_PROGRESS:
                    fileIndex = indexOfFile();
                    if (fileIndex < 0) break;

                    // dont set progress to 100% until we receive confirmation from server
                    var fileProgress = action.progress == 1 ? 0.99 : action.progress;
                    draft.uploadedFiles[fileIndex].progress = fileProgress;
                    break;

                case UploadActions.UPLOAD_SUCCESS:
                    fileIndex = indexOfFile();
                    if (fileIndex < 0) break;
                    draft.uploadedFiles[fileIndex].progress = 1;
                    draft.uploadedFiles[fileIndex].path = action.responsePath;
                    draft.uploadedFiles[fileIndex].isNotDownloadable = action.fileOptions.isNotDownloadable;
                    break;

                case UploadActions.UPLOAD_FAILURE:
                case UploadActions.UPLOAD_DELETE_FAILURE:
                    fileIndex = indexOfFile();
                    if (fileIndex < 0) break;
                    draft.uploadedFiles[fileIndex].failed = true;
                    draft.uploadedFiles[fileIndex].errMsg = action.err.message;
                    draft.uploadedFiles[fileIndex].progress = 0;
                    break;

                case UploadActions.UPLOAD_DELETE_SUCCESS:
                    fileIndex = indexOfFile();
                    if (fileIndex < 0) break;
                    draft.uploadedFiles.splice(fileIndex, 1);
                    break;
            }
        });
    }
}